/**
 * 常量
 *
*/

//采集点列表
export const PATCH_DATA_LIST = 'patch/PATCH_DATA_LIST';

//采集点 详情
export const PATCH_DATA_DETAIL = 'patch/PATCH_DATA_DETAIL';

//采集点 设备列表-显示列表数据
export const PATCH_DEVICE_LIST = 'patch/PATCH_DEVICE_LIST';


//采集点 设备列表 -- 搜索下拉列表数据
export const DEVICE_TYPE_LIST = 'patch/DEVICE_TYPE_LIST';

//采集点 设备列表 -- 子设备列表
export const CHILD_DEVICE_DATA_LIST = 'patch/CHILD_DEVICE_DATA_LIST';

//采集点 查询未添加到采集点的设备列表
export const UN_PATCH_DEVICE_DATA_LIST = 'patch/UN_PATCH_DEVICE_DATA_LIST';

//采集点 根据采集点查询子采集点列表数据
export const CHILD_PATCH_DATA_LIST = 'patch/CHILD_PATCH_DATA_LIST';


export const productList = 'patch/PRODUCTLIST';
